import styled from 'styled-components'

import { ReactComponent as CrownSVG } from 'assets/images/crown.svg'
import { ReactComponent as LockSVG } from 'assets/images/lock.svg'

export const PageTitle = styled.label`
  margin-bottom: ${({ theme }) => theme.spacings[1]};
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.bloggerSans};
  font-weight: 700;
`

export const Heading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin-bottom: ${({ theme }) => theme.spacings[8]};

  span {
    color: ${({ theme }) => theme.colors.primary};
    font-family: ${({ theme }) => theme.fonts.bloggerSans};
    font-size: 24px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: left;
  }

  button {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    font-size: 16px;
  }
`

export const TableHeading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacings[4]};
  margin-bottom: ${({ theme }) => theme.spacings[4]};

  button {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    font-size: 16px;
  }
`

export const OwnerIcon = styled(CrownSVG)`
  color: ${({ theme }) => theme.colors.sand};
  width: ${({ theme }) => theme.fontSizes.md};
`

export const LockIcon = styled(LockSVG)`
  color: ${({ theme }) => theme.colors.blush};
  width: ${({ theme }) => theme.fontSizes.md};
`

export const IconDisabled = styled.span`
  color: ${({ theme }) => theme.colors.pinkishGrey};
  cursor: not-allowed;
`

export const ContainerStatusAssignment = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 5px;
  margin: 0 auto;
`

export const Active = styled(ContainerStatusAssignment)`
  background: ${({ theme }) => theme.colors.background};

  label {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const OtherStatus = styled(ContainerStatusAssignment)`
  background: ${({ theme }) => theme.colors.dangerLight};

  label {
    color: ${({ theme }) => theme.colors.danger};
  }
`

export const Main = styled(ContainerStatusAssignment)`
  background: ${({ theme }) => theme.colors.blueLight};

  label {
    color: ${({ theme }) => theme.colors.blue};
  }
`

export const OtherAssignment = styled(ContainerStatusAssignment)`
  background: ${({ theme }) => theme.colors.warningLight};

  label {
    color: ${({ theme }) => theme.colors.warning};
  }
`
